import { descriptorsFactory } from '../../utils/filters';

export const saleTypeDescriptor = descriptorsFactory({ name: 'saleType', clear: [] })({
  form: [{ key: 'sost_type', type: 'terms', value: ['fz_214'] }],
  label: '214-ФЗ',
  state: 'fz_214',
});
